import React from 'react';
import "./styles/style.css";

const FirstPartySetComponent = () => {
  return (
  <div >
    <iframe src="https://zamar-roura.com/dumpcookies" title="back to business" width="700" height="400"></iframe>
  </div>
);}

FirstPartySetComponent.propTypes = {};

FirstPartySetComponent.defaultProps = {};

export default FirstPartySetComponent;
